import React from 'react';
import { FormattedMessage } from 'react-intl';
import NegativeToast from '@/components/toasts/NegativeToast';

const UsergroupUsersAddErrorToast = ({ group, users }) => (
  <NegativeToast className="aridhia-usergroup-users-add-error-toast" icon="times circle">
    {users.length === 1 && (
      <FormattedMessage
        id="toast.usergroup.user.assign.error"
        values={{ groupName: group.name, userName: users[0].name }}
      />
    )}
    {users.length > 1 && (
      <FormattedMessage
        id="toast.usergroup.users.assign.error"
        values={{ groupName: group.name, userName: users[0].name, count: users.length - 1 }}
      />
    )}
  </NegativeToast>
);

export default UsergroupUsersAddErrorToast;
